// extracted by mini-css-extract-plugin
module.exports = {"delete-button__tooltip":"delete-account-button_delete-button__tooltip__avSDj","delete-button__tooltip-text":"delete-account-button_delete-button__tooltip-text__7k31V"};